module.exports = __webpack_public_path__ + "assets/img/spider.12368f2f.png";